import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";
import { ApiConfigProvider } from "context/ApiConfig/ApiConfigContext";
import UserProvider from "context/User/UserContext";
import { AppConfigProvider } from "context/ConfigContext";
import { logError } from "utils/errorLogger";
import { BrowserRouter as Router } from "react-router-dom";
window.onerror = function (message, source, lineno, colno, error) {
  logError(error || new Error(message), {
    source,
    lineno,
    colno,
  });
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <AppConfigProvider>
      <UserProvider>
        <ApiConfigProvider>
          <App />
        </ApiConfigProvider>
      </UserProvider>
    </AppConfigProvider>
  </Router>
);
